const ROOT_SELECTOR = '.content-body';
const IMAGE_SELECTOR = 'img';
const LIGHTBOX_ACTIVE_CLASS = 'is-active';
const BODY_LOCK_CLASS = 'is-lightbox-open';
const TARGET_CLASS = 'js-lightbox-target';
const LIGHTBOX_IMAGE_SIZES = '90vw';

const parseSrcset = (srcset) => {
  if (!srcset) return [];
  return srcset
    .split(',')
    .map((entry) => entry.trim())
    .filter(Boolean)
    .map((entry) => {
      const [url, descriptor] = entry.split(/\s+/);
      const width = descriptor && descriptor.endsWith('w') ? parseInt(descriptor, 10) : 0;
      return { url, width };
    })
    .filter(({ url }) => Boolean(url));
};

const pickLargestSrc = (srcset, fallback) => {
  const candidates = parseSrcset(srcset);
  if (!candidates.length) return fallback;
  return candidates.reduce((largest, candidate) => (candidate.width > largest.width ? candidate : largest)).url || fallback;
};

const createLightbox = () => {
  const wrapper = document.createElement('div');
  wrapper.className = 'lightbox';
  const picture = document.createElement('picture');
  picture.className = 'lightbox__picture';
  const img = document.createElement('img');
  img.className = 'lightbox__img';
  img.alt = '';
  picture.appendChild(img);
  wrapper.appendChild(picture);
  document.body.appendChild(wrapper);
  return { wrapper, img, picture };
};

document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector(ROOT_SELECTOR);
  if (!root) return;

  const images = [...root.querySelectorAll(IMAGE_SELECTOR)];
  if (!images.length) return;

  const imageSet = new Set(images);

  const { wrapper, img, picture } = createLightbox();

  const removeClonedSources = () => {
    picture.querySelectorAll('source').forEach((node) => node.remove());
  };

  const syncSources = (originPicture) => {
    removeClonedSources();
    if (!originPicture) return;
    const fragment = document.createDocumentFragment();
    originPicture.querySelectorAll('source').forEach((source) => {
      const clone = source.cloneNode(true);
      if (clone.hasAttribute('sizes') || typeof clone.sizes === 'string') {
        clone.setAttribute('sizes', LIGHTBOX_IMAGE_SIZES);
      }
      fragment.appendChild(clone);
    });
    picture.insertBefore(fragment, img);
  };

  const close = () => {
    wrapper.classList.remove(LIGHTBOX_ACTIVE_CLASS);
    document.body.classList.remove(BODY_LOCK_CLASS);
    removeClonedSources();
    img.removeAttribute('src');
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.alt = '';
  };

  const open = (target) => {
    const originPicture = target.closest('picture');
    syncSources(originPicture);
    const nextSrc = pickLargestSrc(target.srcset, target.currentSrc || target.src);
    if (target.srcset) {
      img.srcset = target.srcset;
      img.sizes = LIGHTBOX_IMAGE_SIZES;
    } else {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
    }
    img.src = nextSrc;
    img.alt = target.alt || '';
    wrapper.classList.add(LIGHTBOX_ACTIVE_CLASS);
    document.body.classList.add(BODY_LOCK_CLASS);
  };

  images.forEach((image) => {
    image.classList.add(TARGET_CLASS);
    const picture = image.closest('picture');
    if (picture) {
      picture.classList.add(TARGET_CLASS);
    }
  });

  root.addEventListener('click', (event) => {
    const candidate = event.target.closest('img, picture');
    if (!candidate || !root.contains(candidate)) return;
    const image = candidate.tagName === 'IMG' ? candidate : candidate.querySelector('img');
    if (!image || !imageSet.has(image)) return;

    event.preventDefault();
    open(image);
  });

  wrapper.addEventListener('click', (event) => {
    if (event.target === img) return;
    close();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && wrapper.classList.contains(LIGHTBOX_ACTIVE_CLASS)) {
      event.preventDefault();
      close();
    }
  });
});
